import { render, staticRenderFns } from "./video.vue?vue&type=template&id=d2b6ff90"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"
import style0 from "./video.vue?vue&type=style&index=0&id=d2b6ff90&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2b6ff90')) {
      api.createRecord('d2b6ff90', component.options)
    } else {
      api.reload('d2b6ff90', component.options)
    }
    module.hot.accept("./video.vue?vue&type=template&id=d2b6ff90", function () {
      api.rerender('d2b6ff90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuickAdminTable/video.vue"
export default component.exports